// tslint:disable:max-line-length triple-equals
const IBAN: any = require('iban');
import { ProhibitedIban } from '../models/prohibited-iban.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class ValidationFormService {

    static getValidatorErrorMessage(contolName: string, validatorName: string, validatorValue?: any) {
        const config = {
            'infosCompteForm.Address': {
                'required': 'L\'adresse est requise.',
                'minlength': `L\'adresse doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `L\'adresse ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'infosCompteForm.AddressComplement1': {
                'maxlength': `Le complément d'adresse 1 ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'infosCompteForm.AddressComplement2': {
                'maxlength': `Le complément d'adresse 2 ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'infosCompteForm.City': {
                'required': 'La ville requise.',
                'minlength': `La ville doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `La ville ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'infosCompteForm.PostalCode': {
                'required': 'Le code postal est requis.',
                'minlength': `Le code postal doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `Le code postal ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'infosCompteForm.Country': {
                'required': 'Le pays est requis.',
                'minlength': `Le pays doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `Le pays ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'infosCompteForm.Email': {
                'required': 'L\'Email est requis.',
                'maxLength': `Le email ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`,
                'email': 'L\'Email n\'est pas valide'
            },
            'infosCompteForm.Phone': {
                'required': `Le téléphone est requis.`,
                'maxlength': `Le téléphone ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'infosCompteForm.LastName': {
                'required': 'Le nom est requis.',
                'minlength': `Le nom doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `Le nom ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'infosCompteForm.FirstName': {
                'required': 'Le prénom est requis.',
                'minlength': `Le prénom doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `Le prénom ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'infosCompteForm.Role': {
                'required': 'La fonction est requise.',
                'minlength': `La fonction doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `La fonction ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'sepaMandateForm.RaisonSociale': {
                'required': 'La raison sociale est requise.',
                'minlength': `La raison sociale doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `La raison sociale ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'sepaMandateForm.Adresse': {
                'required': 'L\'adresse est requise.',
                'minlength': `L\'adresse doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `L\'adresse ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'sepaMandateForm.Ville': {
                'required': 'La ville est requise.',
                'minlength': `La ville doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `La ville ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'sepaMandateForm.Cp': {
                'required': 'Le code postal est requis.',
                'minlength': `${validatorValue.requiredLength} caractères minimum.`,
                'maxlength': `${validatorValue.requiredLength} caractères maximum.`
            },
            'sepaMandateForm.Pays': {
                'required': 'Le pays est requis.',
                'minlength': `Le pays doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `Le pays ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'sepaMandateForm.Nom': {
                'required': 'Le nom est requis.',
                'minlength': `Le nom doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `Le nom ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'sepaMandateForm.Prenom': {
                'required': 'Le prénom est requis.',
                'minlength': `Le prénom doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `Le prénom ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'sepaMandateForm.Bic': {
                'required': 'Le Bic est requis.',
                'minlength': `Le Bic doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `Le Bic ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'sepaMandateForm.Iban': {
                'required': 'L\'IBAN est requis.',
                'minlength': `L\'IBAN doit faire au moins ${validatorValue} caractères.`,
                'maxlength': `L\'IBAN ne doit pas faire plus de ${validatorValue} caractères.`,
                'ibanFormat': 'Le format de l\'IBAN est incorrect.',
                'prohibitedIban': 'Bien essayé 😅 ! Merci de saisir un IBAN non attribué'
            },
            'SignatureForm.ContactLastName': {
                'required': 'Le nom est requis.',
                'minlength': `Le nom doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `Le nom ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'SignatureForm.ContactFirstName': {
                'required': 'Le prénom est requis.',
                'minlength': `Le prénom doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `Le prénom ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'SignatureForm.ContactEmail': {
                'required': 'L\'Email est requis.',
                'maxLength': `L\'Email ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`,
                'invalidEmailAddress': 'L\'Email n\'est pas valide'
            },
            'SignatureForm.ContactPhoneNumber': {
                'required': 'Le téléphone est requis.',
                'maxlength': `Le téléphone ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'mailContactForm.MailSubject': {
                'required': 'Le sujet est requis.',
                'minlength': `Le sujet doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `Le sujet ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
            'mailContactForm.MailMessage': {
                'required': 'Le message est requis.',
                'minlength': `Le message doit faire au moins ${validatorValue.requiredLength} caractères.`,
                'maxlength': `Le message ne doit pas faire plus de ${validatorValue.requiredLength} caractères.`
            },
        };

        return config[contolName][validatorName];
    }

    public static alphaNumericOnly(control: any) {
        if (control.value === null || control.value.toLowerCase().trim().match(/^[a-zA-Z0-9]*$/)) {
            return null;
        } else {
            return { 'invalidAlphaNumericOnly': true };
        }
    }

    public static ibanFormatValidator(control: any) {
        if (control.value) {
            const ibanValue = control.value.replace(/\s/g, '');
            if (ibanValue.length < 14) {
                return { 'minlength': 14 };
            }
            if (ibanValue.length > 34) {
                return { 'maxlength': 34 };
            }
            if (!IBAN.isValid(ibanValue) || !ibanValue.match(/^[a-z0-9]+$/i)) {
                return { 'ibanFormat': true };
            }

            const prohibitedIbans = Object.keys(ProhibitedIban).map(key => ProhibitedIban[key]);
            if (prohibitedIbans.some(prohibitedValue => prohibitedValue === ibanValue)) {
                return { 'prohibitedIban': true };
            }
        }
        return null;
    }
}
